module.exports = __webpack_public_path__ + "static/transparent_logo-e981349c435e200353c5e1823cdad38f.png";